<template>
  <v-list-item link :to="route.path" class="routes-list">
    <v-list-item-icon>
      <v-badge offset-x="15px" color="grey" v-if="showBadge" :content="counter">
        <v-icon>{{ route.meta.icon }}</v-icon>
      </v-badge>
      <v-icon v-else>{{ route.meta.icon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>{{ route.meta.title }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { mapGetters } from "vuex";
import { orderStatus } from "@/constants";

export default {
  name: "NavigationItem",
  props: {
    route: {
      require: true,
      type: Object,
    },
  },
  computed: {
    ...mapGetters([
      "tasksLengthsByStatus",
      "ordersToFulfill",
      "shopifyTasksLength",
      "manualFulfillments",
      "ticketsOpen",
      "ticketsWaiting",
      "counters",
    ]),
    showBadge() {
      return this.route.meta.counterStatus && this.counter;
    },
    counter() {
      const cs = this.route.meta.counterStatus;
      if (!cs) return null;

      // Prefer live list length if data has been loaded for this section,
      // otherwise fall back to the counter snapshot loaded at app boot.
      if (cs === "ShopifyOrders") {
        return this.shopifyTasksLength || this.counters.shopifyTasks || 0;
      }
      if (cs === orderStatus.READY_FOR_FULFILL) {
        return this.ordersToFulfill.length || this.counters.ordersToFulfill || 0;
      }
      if (cs === "MANUALFULFILLMETS") {
        return (
          this.manualFulfillments.length || this.counters.manualFulfillments || 0
        );
      }
      if (cs === "SUPPORTCOUNTER") {
        const live =
          (this.ticketsOpen?.length || 0) + (this.ticketsWaiting?.length || 0);
        return live || this.counters.support || 0;
      }
      if (cs === "RATINGS") {
        return this.counters.ratings || 0;
      }
      return this.tasksLengthsByStatus[cs] || this.counters[cs] || 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.task-counter-badge {
  z-index: 100;
  background-color: #858585;
}
</style>
